import Alpine from "alpinejs";

const COMPANY_LINE_BREAKPOINT = "(min-width: 768px)";
const COMPANY_LINE_DURATION = "1.4s";
const COMPANY_LINE_EASING = "cubic-bezier(0, 0, 0.2, 1)";

export const companyLineInview = () => {
  Alpine.data("companyLineInview", () => ({
    isVisible: false,
    targetWidth: "var(--grid-w-1)",
    observer: null as IntersectionObserver | null,
    mediaQuery: null as MediaQueryList | null,
    handleMediaQueryChange: null as ((event: MediaQueryListEvent) => void) | null,

    init() {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.isVisible = true;
      }

      this.mediaQuery = window.matchMedia(COMPANY_LINE_BREAKPOINT);
      this.updateTargetWidth();

      this.handleMediaQueryChange = () => {
        this.updateTargetWidth();
      };

      this.mediaQuery.addEventListener("change", this.handleMediaQueryChange);

      if (this.isVisible) {
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;

          if (!entry?.isIntersecting) {
            return;
          }

          this.isVisible = true;
          this.observer?.disconnect();
          this.observer = null;
        },
        { threshold: 0.35 },
      );

      this.observer.observe(this.$root);
    },

    updateTargetWidth() {
      this.targetWidth = this.mediaQuery?.matches ? "var(--grid-w-2)" : "var(--grid-w-1)";
    },

    lineStyle() {
      return {
        width: this.isVisible ? this.targetWidth : "0px",
        transition: `width ${COMPANY_LINE_DURATION} ${COMPANY_LINE_EASING}`,
      };
    },

    destroy() {
      this.observer?.disconnect();
      this.observer = null;

      if (this.mediaQuery && this.handleMediaQueryChange) {
        this.mediaQuery.removeEventListener("change", this.handleMediaQueryChange);
      }

      this.handleMediaQueryChange = null;
      this.mediaQuery = null;
    },
  }));
};
